import React from 'react';
import { Sidebar } from './Sidebar';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
  onLogout: () => void;
  title?: string;
}
export function Layout({
  children,
  currentPage,
  onNavigate,
  onLogout,
  title
}: LayoutProps) {
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-450">
      <Sidebar currentPage={currentPage} onNavigate={onNavigate} onLogout={onLogout} data-id="element-451" />

      <div className="flex-1 ml-64 flex flex-col min-w-0 overflow-hidden" data-id="element-452">
        {/* Top Header */}
        <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-8 sticky top-0 z-30" data-id="element-453">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-454">
            {title || 'Dashboard'}
          </h1>
          <div className="flex items-center space-x-4" data-id="element-455">
            <span className="text-sm text-gray-500" data-id="element-456">
              Last login: Today, 09:41 AM
            </span>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto p-8" data-id="element-457">{children}</main>
      </div>
    </div>;
}